const TopAnchor = () =>{
    return(
        <a href="#navbar" className="top-anchor">
            <span>Up</span>
        </a>
    );
}

export default TopAnchor;